// src/pages/LegalName.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ProgressTracker from "../components/ProgressTracker"; // ✅ import tracker

const API_WRK = process.env.REACT_APP_API_WRK;

const LegalName = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleNext = async () => {
    const f = firstName.trim();
    const l = lastName.trim();

    if (!f || !l) {
      setError("⚠️ Please enter your full legal name.");
      return;
    }

    const workerId = localStorage.getItem("workerId");
    if (!workerId) {
      setError("Session expired. Please log in again.");
      navigate("/worker-login"); // adjust if your route is different
      return;
    }

    try {
      await axios.post(`${API_WRK}/update-profile`, {
        workerId,
        name: `${f} ${l}`,
      });

      localStorage.setItem("workerFirstName", f);
      localStorage.setItem("workerLastName", l);

      navigate("/verify-phone"); // keep as-is if worker uses same route
    } catch (err) {
      console.error("❌ Error saving name:", err);
      setError(err?.response?.data?.message || "Server error. Please try again.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-100 via-white to-indigo-200 p-4">
      <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md text-center space-y-6">
        {/* ✅ Step tracker on top */}
        <ProgressTracker currentStep={0} />

        <h2 className="text-2xl font-extrabold text-indigo-700">Enter Your Legal Name</h2>
        <p className="text-sm text-gray-600">This name must match your government-issued ID.</p>

        <div className="space-y-4 pt-2">
          <input
            type="text"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            className="w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-400"
          />
          <input
            type="text"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            className="w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-400"
          />

          {error && <p className="text-red-500 text-sm font-medium">{error}</p>}

          <button
            onClick={handleNext}
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 rounded-xl transition"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalName;
